import React from 'react'
import { ButtonInterface } from 'common/types/entities/button-interface'
import { useClosePopup } from 'publisher/hooks/use-close-popup'
import useOptInSubmit from 'publisher/hooks/use-opt-in-submit-new'
import { usePage } from 'publisher/store'
import { getPageId } from 'publisher/store/page/pageSelectors'
import { BasePublisherButton } from 'src/publisher/entities/base-publisher-button'

const TEST_ID = 'send-form-button'

export interface SendFormButtonProps {
  entity: ButtonInterface
}

const SendFormButton = ({ entity }: SendFormButtonProps) => {
  const pageId = usePage(getPageId)
  const closePopup = useClosePopup(entity, pageId)

  const [isLoading, errors, submit, isSuccess] = useOptInSubmit({
    optInButtonEntity: entity,
    closePopup,
  })

  return (
    <BasePublisherButton
      entity={entity}
      isLoading={isLoading}
      errors={errors}
      onClick={submit}
      isSuccess={isSuccess}
      testId={TEST_ID}
    />
  )
}

export default SendFormButton
